/* ws_js_loader.js */

var ws_js = (function (my) {
    my.js_to_run = [];

    my.init = function() {
        for (var i = 0; i < my.js_to_run.length; i++) {
            ws_js.js_to_run[i].init();
        };
    };

    my.add_slot = function(slot) {
        my.js_to_run.push(slot);
    };

    return my;
}(ws_js || {}));



$(document).ready(function() {
    ws_js.init();
});
